export const CATALOG_LOADING = "CATALOG_LOADING";
export const CATALOG_RESET = "CATALOG_RESET";
export const GET_CATALOG = "GET_CATALOG";
export const GET_CATALOG_SUCCESS = "GET_CATALOG_SUCCESS";
export const GET_CATALOG_FAIL = "GET_CATALOG_FAIL";
export const DELETE_CATALOG = "DELETE_CATALOG"
export const DELETE_CATALOG_SUCCESS = "DELETE_CATALOG_SUCCESS"
export const DELETE_CATALOG_FAIL = "DELETE_CATALOG_FAIL"
export const UPDATE_CATALOG = "UPDATE_CATALOG"
export const UPDATE_CATALOG_SUCCESS = "UPDATE_CATALOG_SUCCESS"
export const UPDATE_CATALOG_FAIL = "UPDATE_CATALOG_FAIL"
export const ADD_NEW_CATALOG = "ADD_NEW_CATALOG"
export const ADD_CATALOG_SUCCESS = "ADD_CATALOG_SUCCESS"
export const ADD_CATALOG_FAIL = "ADD_CATALOG_FAIL"
export const CATALOG_RESET_CREATE = "CATALOG_RESET_CREATE"
export const GET_CATALOG_ONE = "GET_CATALOG_ONE"
export const GET_CATALOG_AVAILABLE_ONE = "GET_CATALOG_AVAILABLE_ONE"